import { authTypes } from '../auth/types'
import { EstimateSelectionAction, EstimateSelectionState, estimateSelectionTypes } from './types'

const initialState: EstimateSelectionState = {
  selectedEstimates: [],
  assignMultipleModalOpen: false,
  assignMultipleLoading: false,
}

const reducer = (state = initialState, action: EstimateSelectionAction): EstimateSelectionState => {
  const { type, payload } = action

  switch (type) {
    case authTypes.LOGIN_REQUEST: {
      return initialState
    }

    case authTypes.LOGOUT_REQUEST: {
      return initialState
    }

    case estimateSelectionTypes.TOGGLE_ESTIMATE_SELECTION: {
      const estimateId = payload as string
      const currentSelected = state.selectedEstimates
      const isSelected = currentSelected.includes(estimateId)
      
      return {
        ...state,
        selectedEstimates: isSelected
          ? currentSelected.filter(id => id !== estimateId)
          : [...currentSelected, estimateId]
      }
    }

    case estimateSelectionTypes.CLEAR_SELECTED_ESTIMATES: {
      return {
        ...state,
        selectedEstimates: []
      }
    }

    case estimateSelectionTypes.SET_SELECTED_ESTIMATES: {
      return {
        ...state,
        selectedEstimates: payload as string[]
      }
    }

    case estimateSelectionTypes.SET_ASSIGN_MULTIPLE_MODAL_OPEN: {
      return {
        ...state,
        assignMultipleModalOpen: payload as boolean
      }
    }

    case estimateSelectionTypes.SET_ASSIGN_MULTIPLE_LOADING: {
      return {
        ...state,
        assignMultipleLoading: payload as boolean
      }
    }

    default:
      return state
  }
}

export default reducer
